// extracted by mini-css-extract-plugin
export default {"mainFooter":"footer_mainFooter__QpFwS","containerDiv":"footer_containerDiv__m+kJW","bottomDiv":"footer_bottomDiv__Zn9jc","socialLogo":"footer_socialLogo__iKLCD"};